
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {connect} from 'react-redux'
import {push as pushState} from 'react-router-redux'
import {CSSTransitionGroup} from 'react-transition-group'
import {logoutUser} from 'redux/modules/currentUser/actions'
import Logo from 'components/Logo'
import Icon from 'components/Icon'

export class AuthView extends React.Component {
  static propTypes = {
    pushState: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    isResetPage: PropTypes.bool,
    isSignupPage: PropTypes.bool,
    isLogginIn: PropTypes.bool,
    embedded: PropTypes.string,
    bg: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }

  componentWillMount() {
    const {
      isAuthenticated,
      isLogginIn,
      isSignupPage,
      isResetPage,
      pushState
    } = this.props
    this.checkAuth({
      isAuthenticated,
      isLogginIn,
      isSignupPage,
      isResetPage,
      pushState
    })
  }

  componentWillReceiveProps(props) {
    const {
      isAuthenticated,
      isLogginIn,
      isSignupPage,
      isResetPage,
      pushState
    } = props
    this.checkAuth({
      isAuthenticated,
      isLogginIn,
      isSignupPage,
      isResetPage,
      pushState
    })
  }

  render() {
    const {bg} = this.props

    const classNames = classnames('auth-view_bg', {
      [`with-bg-${bg}`]: !!bg,
      [`with-white-bg`]: !bg
    })

    const wrappedChildren = React.Children.map(this.props.children, (c, i) => (
      React.cloneElement(c, {key: Math.random()})
    ))

    return (
      <div className='auth-view'>
        <div className={classNames} />
        {this.renderLogo()}
        <CSSTransitionGroup
          className='auth-view_transitions'
          transitionName='panel'
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {wrappedChildren}
        </CSSTransitionGroup>
      </div>
    )
  }

  renderLogo() {
    const {embedded, bg} = this.props

    return (
      <div className='auth-view_logo_container'>
        {
          !embedded ? (
            <a className='auth-view_back' href={__WWW_URL__}>
              <Icon
                className='auth-view_back_icon'
                name='arrow-left'
                size='11px'
              />
              Back to divvit.com
            </a>
          ) : null
        }
        <Logo
          link={!embedded}
          className='auth-view_logo'
          inverted={bg !== 'normal'}
          size='medium'
          to={!embedded ? __WWW_URL__ : null}
        />
      </div>
    )
  }

  checkAuth({isAuthenticated, isLogginIn, isSignupPage, isResetPage, pushState}) {
    if (isLogginIn) return false

    if (isAuthenticated && !isResetPage && !isSignupPage) {
      pushState('/')
    }
  }
}

export default connect((state, props) => {
  const {location, routes} = props
  const {bg = false} = routes.concat().pop()

  return {
    bg,
    isLogginIn: state.currentUser.isLogginIn,
    isAuthenticated: state.currentUser.isAuthenticated,
    isResetPage: location.pathname === '/reset',
    isSignupPage: location.pathname === '/register',
    isLoginPage: location.pathname === '/login',
    embedded: location.query.embedded
  }
}, {
  pushState,
  logoutUser
})(AuthView)

export {default as SignIn} from './SignIn'
export {default as SignUp} from './SignUp'
export {default as ForgotForm} from './ForgotForm'
export {default as SetPasswordForm} from './SetPasswordForm'



// WEBPACK FOOTER //
// ./client/views/AuthView/index.js